import type { ModuleFile } from '../../core/modules.ts';

// Módulo «rights»: manifiesto. Las pantallas se cargan de forma perezosa.
export const manifests: ModuleFile['manifests'] = [
  {
    id: 'rights',
    title: 'Derechos',
    path: 'derechos',
    nav: { group: 'Canal', label: 'Derechos', icon: '§', order: 4 },
    load: () => import('./RightsPage.tsx').then((m) => ({ default: m.RightsPage })),
  },
];
